<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17koj3g/tc-custom/9781453237519.jpg?1705435308968" alt="This image is the cover for the book Crooked Hearts"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Crooked Hearts
      </h1>
      <p class="bookDescription body article font2">
        <b>Two con artists team up in 1880s California for the score of a lifetime—but end up fighting for their lives instead</b> In a stagecoach en route to San Francisco, Grace Rousselot is posing as a nun to drum up “donations” from fellow travelers. Across from her, Reuben Jones is faking blindness to prey on unsuspecting travelers. Both grifters are surprised to learn that they have competition, and even more surprised when their stagecoach is ambushed and robbed, leaving them both flat broke. Not keen to discuss the robbery with the police, Reuben and Grace decide to work together to recoup some of their losses. Soon enough, what starts out as a practical partnership evolves into something more. And with the Chinese mafia hot on their heels, neither is sure just how far they can trust a man—or a woman—with a crooked heart.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia Gaffney
      </h2>
      
      <p class="authorDescription body article">&amp;lt;p&amp;gt;Patricia Gaffney's novels include &amp;lt;em&amp;gt;The Goodbye Summer&amp;lt;/em&amp;gt;, &amp;lt;em&amp;gt;Flight Lessons&amp;lt;/em&amp;gt;, and &amp;lt;em&amp;gt;The Saving Graces&amp;lt;/em&amp;gt;. She and her husband currently live in Blue Ridge Summit, Pennsylvania.&amp;lt;/p&amp;gt;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?673ecf4e